import React from 'react';
import { Card, CardContent } from './ui/card';
import { Quote, Star } from 'lucide-react';

const Testimonials = ({ testimonialsData }) => {
  if (!testimonialsData || testimonialsData.length === 0) return null;

  return (
    <section className="py-24 px-6 relative overflow-hidden bg-black">
      <div className="container mx-auto max-w-6xl relative z-10">
        <div className="text-center mb-16">
          <div className="inline-flex items-center space-x-2 px-4 py-2 rounded-full bg-[#D4AF37]/10 border border-[#D4AF37]/30 mb-6">
            <Star className="w-4 h-4 text-[#D4AF37]" />
            <span className="text-sm font-medium text-white" style={{ fontFamily: 'Montserrat, sans-serif' }}>Testimonials</span>
          </div>
          
          <h2 className="text-5xl md:text-6xl font-bold mb-6 text-white" style={{ fontFamily: 'Cinzel, serif' }}>
            Voices of Resonance
          </h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto">
            What listeners and critics are saying
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {testimonialsData.map((testimonial, index) => (
            <Card 
              key={testimonial.id}
              className="bg-black border-2 border-[#D4AF37]/20 hover:border-[#D4AF37]/50 transition-all duration-300 group"
            >
              <CardContent className="p-8 space-y-6">
                <div className="flex items-center justify-between">
                  <Quote className="w-10 h-10 text-[#D4AF37] opacity-40 group-hover:opacity-70 transition-opacity" />
                  <div className="flex space-x-1">
                    {[...Array(5)].map((_, i) => (
                      <Star key={i} className="w-4 h-4 text-[#D4AF37] fill-[#D4AF37]" />
                    ))}
                  </div>
                </div>
                
                <blockquote className="text-base text-gray-300 leading-relaxed italic">
                  "{testimonial.quote}"
                </blockquote>
                
                <div className="pt-4 border-t border-[#D4AF37]/20 space-y-1">
                  <p className="text-sm font-semibold text-[#D4AF37]">
                    {testimonial.author}
                  </p>
                  <p className="text-xs text-gray-500">
                    {testimonial.source}
                  </p>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;